<template>
  <div>
    <v-card id="welcome-banner">
      <h1 class="text-center">Welcome to Telemonial!</h1>
      <v-card-actions class="d-flex justify-center">
        <v-btn color="accent" :to="{ name: 'create-account' }"> Join Now </v-btn>
      </v-card-actions>
    </v-card>

    <div class="d-flex features">
      <div class="reviews-feature">
        <h2 id="review-intro">Create Reviews</h2>
        <div id="sample-reviews">
          <review-tile type="individual" :data="sampleReview1" :class="{ 'mr-0': $vuetify.breakpoint.width >= 990 }" />
          <review-tile
            v-if="!$vuetify.breakpoint.xs"
            type="individual"
            :data="sampleReview2"
            :class="{ 'mr-0': $vuetify.breakpoint.width >= 990 }"
          />
        </div>
      </div>

      <div v-if="$vuetify.breakpoint.width >= 990" id="divider" class="d-flex justify-center">
        <v-divider vertical></v-divider>
      </div>

      <div class="explore-feature">
        <h2 id="explore-intro">Explore your favorite...</h2>

        <v-card class="carouselWrapper">
          <h2>Films</h2>
          <list-swiper :works="top_films" medium="film" :breakpoints="swiperBreakpoints"></list-swiper>
        </v-card>

        <v-card class="carouselWrapper">
          <h2>Books</h2>
          <list-swiper :works="top_books" medium="book" :breakpoints="swiperBreakpoints"></list-swiper>
        </v-card>

        <v-card class="carouselWrapper">
          <h2>Albums</h2>
          <list-swiper :works="top_albums" medium="album" :breakpoints="swiperBreakpoints"></list-swiper>
        </v-card>

        <v-card class="carouselWrapper">
          <h2>Podcasts</h2>
          <list-swiper :works="top_podcasts" medium="podcast" :breakpoints="swiperBreakpoints"></list-swiper>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import getTopWorks from "../../mixins/getTopWorks";
import ReviewTile from "../../components/review-tile.vue";
import ListSwiper from "../../components/list-swiper.vue";

function getSampleMovieId() {
  const AS_ABOVE_SO_BELOW_ID = {
    production: 973,
    development: 4216,
  };
  return AS_ABOVE_SO_BELOW_ID[process.env.NODE_ENV];
}

function getSamplePodcastId() {
  const STUFF_TO_BLOW_YOUR_MIND_ID = {
    production: 9,
    development: 205,
  };
  return STUFF_TO_BLOW_YOUR_MIND_ID[process.env.NODE_ENV];
}

export default {
  name: "HomeNoLogin",

  components: { ReviewTile, ListSwiper },

  mixins: [getTopWorks],

  data: function () {
    return {
      top_films: [],
      top_books: [],
      top_podcasts: [],
      top_albums: [],

      swiperBreakpoints: {
        0: {
          slidesPerView: 1.45,
        },
        430: {
          slidesPerView: 1.7,
        },
        530: {
          slidesPerView: 2,
        },
        710: {
          slidesPerView: 3,
        },
        860: {
          slidesPerView: 4,
        },
        990: {
          slidesPerView: 3,
        },
        1250: {
          slidesPerView: 4,
        },
        1545: {
          slidesPerView: 5,
        },
      },

      sampleReview1: {
        work: {
          title: "As Above, So Below",
          id: getSampleMovieId(),
          medium: "film",
          posterSource: "https://image.tmdb.org/t/p/original/oJZSajKLJkoTOzSZQN2ZwRnPwHZ.jpg",
        },
        author: {
          username: "Telemonial",
        },
        review:
          "I thoroughly enjoyed this movie. It’s a great blend of conspiracy mystery, paranormal, and just straight creepy. It does a great job of building anxiety, even though the claustrophobia scene isn’t the most believable (sorry, but I don’t think any movie will ever beat The Descent there).\n" +
          "\n" +
          "Unfortunately, this film is not without its flaws. For instance, being a found footage, or at least very close to it, I cannot tell what noises are actually occurring, and what noises are camera malfunctions or background music. \n" +
          "\n" +
          "Additionally, this film could’ve done a much better job of isolating the characters. In a setting where people will be forced to traverse between passages single-file, much more could have been done with picking off the stragglers. And at the peak moment, where the movie could have been the most terrifying, they speed-run through it. \n" +
          "\n" +
          "Still, the story is great, the catacombs are always interesting, and this movie did a great job of entertaining me.",
        rating: 8,
        id: 0,
        comments: {
          items: [],
        },
      },

      sampleReview2: {
        work: {
          title: "Stuff to Blow Your Mind",
          medium: "podcast",
          id: getSamplePodcastId(),
          posterSource:
            "https://production.listennotes.com/podcasts/stuff-to-blow-your-mind-iheartradio-ASFQoB05DI8-fJKPYXUrITN.300x300.jpg",
        },
        author: {
          username: "Telemonial",
        },
        review:
          "I absolutely love this podcast, even though it may be nerdy in every single way. The shows span a variety of topics, such as thought experiments like Roko's Basilisk and relics from ancient civilizations. They even explore popular monsters and either synthesize it to a scientific concept, or else expound on what the cultural significance of the monster might have been.",
        rating: 10,
        id: 0,
        comments: {
          items: [],
        },
      },
    };
  },

  mounted() {
    // Populate the Carousels
    for (let medium of Object.values(this.$mediums)) {
      this.getTopWorks(medium).then((response) => {
        this[`top_${medium}s`] = response;
      });
    }
  },
};
</script>

<style scoped>
#welcome-banner {
  margin-bottom: 30px;
}

@media (max-width: 989px) {
  .features {
    flex-direction: column;
  }

  #sample-reviews {
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
}

@media (min-width: 990px) {
  .reviews-feature {
    width: 25%;
    max-width: 300px;
  }
  .explore-feature {
    width: 70%;
  }
}

#review-intro,
#explore-intro {
  font-size: 1.7em;
}

#sample-reviews > * {
  margin-bottom: 20px;
}

#divider {
  flex-grow: 1;
}

.carouselWrapper {
  margin-bottom: 20px;
}

.carouselWrapper > h2 {
  padding-left: 30px;
  font-size: 1.7em;
}
</style>
